import TableComponent from './Table.vue';
import TableOptions from './TableOptions.vue';
import defaultTableConfig from './defaultTableConfig';
import * as columnTemplates from './columnTemplates';

export * from './types';
export * from './tableHelpers';
export {
    TableComponent as default,
    TableComponent,
    TableOptions,
    // todo: stop exporting this outside of Table
    // remove after rewrite all tables with this component
    defaultTableConfig,
    columnTemplates,
};
